import en from "@/locales/en.json";

const locales = { en };
let current = "en";

export function setLocale(code) {
  if (locales[code]) current = code;
}

export function t(key, vars = {}) {
  const value = key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), locales[current]);
  const str = value === undefined ? key : value;
  return String(str).replace(/\{\{(\w+)\}\}/g, (_, name) => (vars[name] !== undefined ? vars[name] : `{{${name}}}`));
}
